<template>
  <div class="messageCenter">
    <div class="tabs">
      <div class="appInfo">
        {{ appInfo.appName }}
      </div>
      <el-button type="primary" size="small" @click="goBack">返回应用管理</el-button>
    </div>
    <div class="body">
      <div class="top">
        <el-form inline class="form" size="small">
          <el-form-item>
            <el-button size="small" type="primary" @click="viewModule(0, { pid: appInfo.permissionId })"> 新增 </el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <el-input v-model="searchName" clearable size="small" placeholder="请输入资源名称">
              <i slot="suffix" class="el-icon-search el-input__icon" />
            </el-input>
          </el-form-item>
        </el-form>
        <el-row>
          <el-checkbox v-model="oneMenuHideList" @change="handleOneMenuShowChange">只有一个菜单时，在运行时不显示菜单</el-checkbox>
        </el-row>
      </div>
      <div class="table">
        <el-table
          key="isRead"
          ref="messageData"
          v-loading="loading"
          element-loading-text="拼命加载中"
          row-key="permissionId"
          highlight-current-row
          :indent="20"
          :tree-props="{ children: 'childList', hasChildren: 'hasChildren_' }"
          :data="allModule"
          height="100%"
          border
          :row-class-name="addclass"
          :expand-row-keys="expandRow"
          class="treeTab"
          @current-change="handleCurrentChange"
        >
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
          </template>
          <el-table-column class-name="table-module-name" label="资源名称" min-width="260px">
            <template #default="{ row }">
              <!-- <el-checkbox v-model="row.isChecked" :true-label="1" :false-label="0" @change="setTreeLimit(row)"> -->
              <span class="row-icon">
                <img v-if="row.resourceType == 0" :src="P_MENU" alt="" />
                <img v-else-if="row.resourceType == 1" :src="P_BUTTON" alt="" />
                <img v-else :src="P_PAGE" alt="" />
              </span>
              <el-link type="primary" :class="[row.isUse == 0 ? '' : 'noIsUse']" @click="openUpdateModule(row)">
                <span :ref="row.permissionId" class="tabLinkSpan" :title="row.permissionName">{{ row.permissionName }}</span>
              </el-link>
              <!-- </el-checkbox> -->
            </template>
          </el-table-column>
          <el-table-column label="排序" type="type" prop="sortNum" align="center" min-width="80px" />
          <el-table-column label="类型" align="center" min-width="100px">
            <template #default="{ row }">
              <span v-if="row.resourceType == 0">菜单</span>
              <span v-else-if="row.resourceType == 1">按钮</span>
              <span v-else>页面</span>
            </template>
          </el-table-column>
          <el-table-column label="请求地址" prop="location" min-width="300px" align="center" />
          <el-table-column label="权限标志" prop="permissionKey" min-width="200px" align="center" />
          <el-table-column label="资源状态" prop="isUse" min-width="100px" align="center">
            <!-- :filtered-value="filterText" -->
            <template #default="{ row }">
              <span v-if="row.isUse == 0">启用</span>
              <span v-else style="color: red">禁用</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" min-width="300px" align="center">
            <template #default="{ row }">
              <el-button v-if="!isDynamicRouterBtn(row)" type="text" size="small" @click="openUpdateModule(row)"> 修改 </el-button>
              <el-button v-if="row.isUse == 1" type="text" size="small" @click="isUserModule(row)"> 启用 </el-button>
              <el-button v-if="row.isUse == 0" type="text" size="small" @click="isUserModule(row)"> 禁用 </el-button>
              <el-button type="text" size="small" @click="deleteModuleHandler(row)"> 删除 </el-button>
              <el-button v-if="!isDynamicRouterBtn(row)" type="text" size="small" @click="viewModule(0, { pid: row.permissionId })"> 添加 </el-button>
              <el-button v-if="row.dynamicRouter && row.useTemplate !== 1" type="text" size="small" @click="editForm(row.formCode)"> 打开表单 </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <permissionDlg
      ref="editModule"
      :moduleForm="moduleForm"
      :allModuleProp="allModuleProp"
      :moduleSelectTree="moduleSelectTree"
      :groupList="groupList"
      :treeMetaData="treeMetaData"
      :currentRow="currentRow"
      @closeEditModule="closeEditModule"
      @submitEditModuleHandler="submitEditModuleHandler"
    ></permissionDlg>
    <permissionDelDlg ref="delDlg" @submitDelPermission="submitDelPermission"> </permissionDelDlg>
  </div>
</template>

<script>
import applicationSettingsService from "@/CommonDP/service/applicationSettings-service";
import treeUtils from "@/CommonDP/utils/treeUtils";
import basePermissionVue from "@/CommonDP/adminPages/settings/resources/basevue.js";

export default {
  extends: basePermissionVue,
  props: {
    appInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      oneMenuHideList: false,
      tableData: [],
      appAllTableData: [],
      isRead: 2,
      searchName: "",
      expandRow: [],
      batchDelList: []
    };
  },
  computed: {
    // 下拉父级
    moduleSelectTree() {
      const { appAllTableData } = this;
      const list =
        appAllTableData?.map((item) => {
          if (item.childList.length === 0) {
            item.isLeaf = true;
            return {
              permissionName: item.permissionName,
              permissionId: item.permissionId,
              isLeaf: true
            };
          } else {
            return item;
          }
        }) || [];
      return [
        {
          permissionName: "根目录",
          permissionId: "0",
          isLeaf: true
        },
        ...list
      ];
    },
    allModule() {
      const { searchName, tableData } = this;
      const searchValue = searchName;
      if (searchValue) {
        const handleTreeData = this.handleTreeData(tableData, searchValue);
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.expandRow = [];
        this.setExpandRow(handleTreeData);
        return handleTreeData;
      }
      // 只有在上一次是搜索状态本次是非搜索状态才进行处理
      if (this.findingLocation && this.currentRow) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.findingLocation = false;
        // 如果筛选状态下点击某行高亮，则滚动屏幕到高亮行
        this.$nextTick(() => {
          const expandRow = treeUtils.findPathInTree(tableData, "permissionId", "childList", this.currentRow.permissionId);
          console.log("expandRow", expandRow);
          const viewY = this.$refs[expandRow.at(-1).permissionId].getBoundingClientRect().y;
          const elBody = this.$refs.messageData.$el.querySelector(".el-table__body-wrapper");
          const elBodyY = elBody.getBoundingClientRect().y;
          const elBodyH = elBody.getBoundingClientRect().height;
          console.log(viewY, elBodyY, elBodyH);
          elBody.scrollTop = viewY - elBodyY - elBodyH / 4;
          this.$refs.messageData.setCurrentRow(expandRow.at(-1));
        });
      }
      return tableData;
    }
  },

  mounted() {
    this.getModuleAllList();
    this.getOneMenuShowChange();
  },
  methods: {
    handleOneMenuShowChange(val) {
      applicationSettingsService.setOnlyChildMemuShowList(this.appInfo.appCode, val ? 2 : 1).then((res) => {});
    },
    getOneMenuShowChange() {
      applicationSettingsService.getOnlyChildMemuShowList(this.appInfo.appCode).then((res) => {
        this.oneMenuHideList = !!res.data;
      });
    },

    goBack() {
      this.$emit("backPage");
    },

    refreshCurTableData() {
      this.getModuleList();
      this.getModuleAllList();
    },
    // 所有的树
    async getModuleList() {
      this.loading = true;
      const { data } = await applicationSettingsService.queryPermissionTree(this.appInfo.appCode);
      this.loading = false;
      this.tableData = this.disposeData(data);
    },

    async getModuleAllList() {
      const { data } = await applicationSettingsService.queryAllAppPermissionTree();
      this.appAllTableData = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.form {
  .el-form-item {
    margin-bottom: 0;
  }
}

.appInfo {
  display: flex;
  justify-content: space-between;
  font-weight: 700;
  font-size: 14px;
}

.messageCenter {
  height: 100%;
  display: flex;
  flex-direction: column;
  min-width: 700px;

  /deep/.el-form-item {
    margin-bottom: 16px;
  }

  .tabs {
    height: 60px;
    padding: 0 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    background-color: #fff;
    border-bottom: 1px solid #ebefff;
    align-items: center;
  }

  .body {
    height: calc(100% - 70px);
    background-color: #fff;
    padding-bottom: 10px;
    position: relative;

    .top {
      padding: 12px 20px 0px 20px;
    }

    .table {
      position: absolute;
      padding: 0 20px;
      left: 0;
      right: 0;
      bottom: 10px;
      top: 85px;
      .noIsUse {
        color: #ccc;
      }
      .noIsUse:hover:after {
        border-color: #ccc;
      }
      .el-button--text {
        padding: 0 !important;
      }
    }
  }

  .width-220 {
    width: 100%;
  }

  .el-table /deep/ .warm-row {
    color: #ccc;
  }

  .row-icon {
    margin-right: 6px;
    img {
      vertical-align: middle;
      width: 18px;
      height: 18px;
    }
  }
}

.dialog-form {
  height: 70vh;
  padding-right: 12px;
  overflow: auto;
}

::v-deep(.el-table__row:not([class*="el-table__row--level-"])) {
  td:first-child {
    padding-left: 23px;
  }
}

::v-deep {
  .el-table__placeholder {
    margin-left: 3px;
  }

  .cell {
    font-size: 14px;

    span {
      font-size: 14px;
    }
  }
}
.delPermissionBox {
  padding: 5px 16px;
  .titleError {
    font-size: 16px;
    margin-bottom: 10px;
  }
  .title {
    margin-bottom: 10px;
    font-size: 16px;
    margin-left: 5px;
  }
  .checkbox {
    margin-bottom: 5px;
    margin-left: 5px;
    font-size: 16px;
  }
  .password {
    padding-left: 30px;
    span {
      margin-right: 5px;
      font-size: 14px;
    }
  }
}
</style>
